import React, { createContext, useContext, useState, useCallback, useRef } from "react";

const KeyboardContext = createContext(null);

export const useKeyboard = () => {
  const ctx = useContext(KeyboardContext);
  if (!ctx) {
    return {
      visible: false,
      layoutName: "default",
      keyboardRef: { current: null },
      onKeyboardChange: () => { },
      onKeyPress: () => { },
      closeKeyboard: () => { },
      registerInput: () => { },
    };
  }
  return ctx;
};

export const KeyboardProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const keyboardRef = useRef(null);

  // The currently active input's callback and name
  const activeInputRef = useRef({ name: "", onChange: null });

  // Called by an input field when it gains focus / is clicked
  const registerInput = useCallback((name, value, onChange) => {
    activeInputRef.current = { name, onChange };
    if (keyboardRef.current) {
      keyboardRef.current.setInput(String(value ?? ""));
    }
    setVisible(true);
  }, []);

  // Called by the keyboard when a key produces a new value
  const onKeyboardChange = useCallback((value) => {
    const { onChange } = activeInputRef.current;
    if (onChange) {
      onChange(value);
    }
  }, []);

  const onKeyPress = useCallback((button) => {
    if (button === "{shift}" || button === "{lock}") {
      setLayoutName((prev) => (prev === "default" ? "shift" : "default"));
    }
  }, []);

  const closeKeyboard = useCallback(() => {
    setVisible(false);
    activeInputRef.current = { name: "", onChange: null };
  }, []);

  return (
    <KeyboardContext.Provider
      value={{ visible, layoutName, keyboardRef, registerInput, onKeyboardChange, onKeyPress, closeKeyboard }}
    >
      {children}
    </KeyboardContext.Provider>
  );
};
